"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.replaceCurrentUrl = void 0;
var replaceCurrentUrl = function(url) {
    return window.history.replaceState({}, '', url);
};
exports.replaceCurrentUrl = replaceCurrentUrl; //# sourceMappingURL=replaceCurrentUrl.js.map
